
import React from 'react';
import { Helmet } from 'react-helmet';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { FileText, Upload } from 'lucide-react';
import CertificateTemplateLibrary from '@/components/student-certification/certificate-templates/CertificateTemplateLibrary';

const CertificateTemplatesPage = () => {
  return (
    <div className="container mx-auto py-8">
      <Helmet>
        <title>Certificate Templates | NALC</title>
      </Helmet>
      
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Certificate Templates</h1>
        <p className="text-muted-foreground mt-2">
          Manage certificate templates for different types of certifications
        </p>
      </div>
      
      <div className="mb-6">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle>Enhanced Certificate Templates</CardTitle>
            <CardDescription>
              Create and manage beautiful certificates for your students and courses
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Alert className="bg-blue-50 text-blue-800 border-blue-200">
              <AlertDescription className="flex flex-col gap-2">
                <div className="flex items-center">
                  <Upload className="h-5 w-5 mr-2" />
                  <span className="font-semibold">
                    NEW: Custom PDF Certificate Templates
                  </span>
                </div>
                <p>
                  You can now upload your own colorful PDF certificate designs and map dynamic data fields to them.
                  The system will automatically overlay student data onto your PDF templates when generating certificates.
                </p>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="text-xs bg-blue-100 px-2 py-1 rounded">Upload PDF designs</span>
                  <span className="text-xs bg-blue-100 px-2 py-1 rounded">Map data fields</span>
                  <span className="text-xs bg-blue-100 px-2 py-1 rounded">Preview with sample data</span>
                  <span className="text-xs bg-blue-100 px-2 py-1 rounded">Generate beautiful certificates</span>
                </div>
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>
      </div>
      
      <CertificateTemplateLibrary />
    </div>
  );
};

export default CertificateTemplatesPage;
